const API_URL = process.env.REACT_APP_API_URL || 'https://apiprov.conduto.com.ec';

export const getFilePreviewUrl = (politica) => {
  if (politica.archivo instanceof File) {
    return URL.createObjectURL(politica.archivo);
  }

  if (politica.ruta_archivo) {
    return `${API_URL}/api/documentos/visualizar/${politica.ruta_archivo}`;
  }

  return null;
};

export const getDownloadUrl = (politica) => {
  if (!politica.ruta_archivo) return null;
  return `${API_URL}/api/documentos/visualizar/${politica.ruta_archivo}?download=true`;
};

export const getFileName = (fileData) => {
  if (!fileData) return "Documento PDF";

  if (fileData.archivo instanceof File) {
    return fileData.archivo.name;
  }

  if (fileData instanceof File) {
    return fileData.name;
  }

  if (fileData.ruta_archivo) {
    const parts = fileData.ruta_archivo.split('_');
    if (parts.length > 2) {
      return parts.slice(2).join('_');
    }
    return fileData.ruta_archivo;
  }

  return "Documento PDF";
};